/**
 * Browser storage can be unavailable in privacy-restricted and embedded webviews.
 * Treat persisted preferences as optional so a storage policy never prevents the
 * application from rendering.
 */
export function getStoredValue(key: string): string | null {
  if (typeof window === "undefined") return null

  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function setStoredValue(key: string, value: string): boolean {
  if (typeof window === "undefined") return false

  try {
    window.localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export function removeStoredValue(key: string): boolean {
  if (typeof window === "undefined") return false

  try {
    window.localStorage.removeItem(key)
    return true
  } catch {
    return false
  }
}
